import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { PROFILE } from "@/data/profile";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-white">
      <div className="wrap py-20 lg:py-28">
        <Reveal>
          <p className="mb-4 block text-[11px] font-semibold uppercase tracking-[0.2em] text-white/60">
            Start a conversation
          </p>
          <a
            href={`mailto:${PROFILE.email}`}
            data-testid="footer-email-link"
            className="break-all font-serif text-3xl leading-tight text-white transition-colors duration-300 hover:text-[#7DA0FF] sm:text-4xl lg:text-6xl"
          >
            {PROFILE.email}
          </a>
        </Reveal>

        <div className="mt-16 grid gap-10 border-t border-white/15 pt-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">Navigate</p>
            <ul className="mt-4 space-y-2">
              {[
                { to: "/about", label: "About" },
                { to: "/research", label: "Research & Papers" },
                { to: "/blog", label: "Blog & Articles" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">Direct</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>
                <a href={`mailto:${PROFILE.email}`} className="transition-colors hover:text-white">
                  {PROFILE.email}
                </a>
              </li>
              <li>
                <a href={`tel:${PROFILE.phoneHref}`} className="transition-colors hover:text-white">
                  {PROFILE.phone}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">Elsewhere</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>
                <a href={PROFILE.linkedinUrl} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                  LinkedIn — {PROFILE.linkedinLabel}
                </a>
              </li>
              <li>{PROFILE.location}</li>
            </ul>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">The Desk</p>
            <p className="mt-4 font-serif italic text-white/70">
              All <span className="italic text-[#7DA0FF]">Elite</span> Research.
            </p>
            <p className="mt-2 text-[9px] font-semibold uppercase tracking-[0.3em] text-white/40">
              Research-led Strategy Consulting
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">
            © {year} All Elite Research
          </p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50 transition-colors hover:text-white">
            Editorial Desk
          </Link>
        </div>
      </div>
    </footer>
  );
}